// Kept for backwards compatibility with existing imports.
// Fluxo oficial: se o usuário não estiver autenticado, criamos a conta primeiro
// em /cadastro. Se já estiver autenticado, vamos direto para /checkout.

import { supabase } from "@/integrations/supabase/client";

export async function openCheckout() {
  if (typeof window === "undefined") return;
  try {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      window.location.href = "/checkout";
      return;
    }
  } catch {
    // ignore, fallback to cadastro
  }
  window.location.href = "/cadastro";
}

export function CheckoutDialog() {
  return null;
}
